<template>
    <section class="search-query">
        <div class="box-but-copy">
            <b-button v-if="!isCopyToClipboard" class="but-copy" v-on:click="setToClipboard"
                      v-b-tooltip.hover title="Копировать">
                Копировать
            </b-button>
        </div>
        <b-textarea v-model="clipboardText" v-if="isCopyToClipboard" ref="clipboardRef"></b-textarea>
        <b-container fluid v-if="!isCopyToClipboard">
            <b-row v-for="ruQuery in searchQueries" v-bind:key="ruQuery.id">
                <b-col :cols="typeRu ? 8 : 10" class="search-name-box">
                    <b-container fluid>
                        <b-row>
                            <b-col :cols="4" class="text-right">{{ nFormat(ruQuery.frequency) }}</b-col>
                            <b-col :cols="8" class="text-left">
                                <i
                                        v-if="isEditQueries[ruQuery.id] == undefined || !isEditQueries[ruQuery.id]"
                                        v-on:click="editQueries(ruQuery.id)"
                                >{{ ruQuery.query }}</i>
                                <b-input
                                        v-model="searchQueries[ruQuery.id]['query']"
                                        v-show="isEditQueries[ruQuery.id] != undefined && isEditQueries[ruQuery.id]"
                                        v-on:change="editQueries(ruQuery.id, true)"
                                        v-on:input="inputProcessingEdit(ruQuery.id)"
                                        :ref="'editQueries_'+ ruQuery.id"
                                        size="sm"
                                        class="mb-1"
                                        v-if="searchQueries[ruQuery.id] != undefined"
                                        v-on:focusout="handleFocusout(ruQuery.id)"
                                ></b-input>
                                <label v-if="duplicateQueriesEdit[ruQuery.id]">дубликат</label>
                                <label v-if="upMaxLengthEdit[ruQuery.id]">лимит 35 превышен</label>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
                <b-col :cols="typeRu ? 4 : 2" class="search-link-box">
                    <b-container fluid>
                        <b-row>
                            <b-col cols="auto" v-if="typeRu">
                                <a :href="'https://wordstat.yandex.ru/#!/?words='+ encodeURI(ruQuery.query)" target="_blank">WS</a>
                            </b-col>
                            <b-col cols="auto" v-if="typeRu">
                                <a :href="'https://yandex.ru/search/?text='+ encodeURI(ruQuery.query)" target="_blank">Я</a>
                            </b-col>
                            <b-col cols="auto">
                                <a :href="'https://www.google.com/search?q='+ encodeURI(ruQuery.query)" target="_blank">G</a>
                            </b-col>
                            <b-col>
                                <button type="button" class="but-remove close b-form-tag-remove ml-1" v-on:click="queryDelete(ruQuery.id)">×</button>
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mt-2 ml-2 mr-1">
                <b-col cols="2"></b-col>
                <b-col cols="10">
                    <label v-if="duplicateQueries">дубликат</label>
                    <label v-if="upMaxLength">лимит 35 символов превышен для запросов с разделением "|"</label>
                    <b-textarea
                            size="sm"
                            class="mb-2 query-input"
                            rows="1"
                            v-model="newQueries"
                            v-on:change="addNewQuery"
                            placeholder="Введите запрос"
                            v-on:input="inputProcessing"
                    >
                    </b-textarea>
                    <button type="button" class="but-add-queries but-remove close b-form-tag-remove ml-1">+</button>
                </b-col>

            </b-row>
        </b-container>
    </section>
</template>

<script>
    export default {
        name: "SearchQuery",
        props: {
            searchQueries: Object,
            typeRu: Boolean,
            change: Function
        },
        data() {
            return {
                isEditQueries: {},
                newQueries: null,
                duplicateQueries: false,
                upMaxLength: false,
                clipboardText: '',
                isCopyToClipboard: false,
                duplicateQueriesEdit: {},
                upMaxLengthEdit: {},
            }
        },
        methods: {
            nFormat: function (number) {
              if (number === null || number === '') {
                return 'н/д';
              }
                return new Intl.NumberFormat('ru-RU').format(number);
            },
            getMaxKey: function(object) {
                let maxKey = -1;
                for(let key in object) {
                    if (parseInt(key) > maxKey) {
                        maxKey = key;
                    }
                }
                return maxKey;
            },
            addNewQuery: function () {
                if (this.duplicateCheck(this.newQueries)) {
                    return false;
                }
                if (this.lengthExceeding(this.newQueries)) {
                    return false;
                }
                let maxKey = this.getMaxKey(this.searchQueries);
                maxKey ++;
                let newKey = maxKey;
                let queriesSplit = this.newQueries.split("\n");
                queriesSplit.forEach((val) => {
                  if (val && val.trim() != '') {
                    let tabSplit = val.split("\t");
                    let frequency = 0;
                    if (tabSplit.length > 1) {
                      frequency = tabSplit[1];
                    }
                    this.$set(this.searchQueries, newKey, {
                      id: newKey,
                      frequency: frequency,
                      query: tabSplit[0],
                      isNew: true
                    });
                    newKey++;
                  }
                });
                this.newQueries = null;
                this.change()
            },
            inputProcessing: function () {
              this.duplicateCheck(this.newQueries);
              this.lengthExceeding(this.newQueries);
            },
            inputProcessingEdit: function (id) {
              this.duplicateCheck(this.searchQueries[id]['query'], id);
              this.lengthExceeding(this.searchQueries[id]['query'], id);
            },
            editQueries: function (id, isStop = false) {
                if (
                    this.duplicateCheck(this.searchQueries[id]['query'], id) ||
                    this.lengthExceeding(this.searchQueries[id]['query'], id)
                ) {
                  return false;
                }
                for (let key in this.isEditQueries) {
                    this.$set(this.isEditQueries, key, false);
                }

                this.$set(this.isEditQueries, id, !isStop);
                this.$nextTick(() => {
                    this.$refs['editQueries_'+ id][0].focus();
                });
                if (isStop) {
                  this.change()
                }
            },
            queryDelete: async function (id) {
                for(let key in this.searchQueries) {
                    if (key == id) {
                        delete this.searchQueries[key];
                        this.change()
                        this.$forceUpdate();
                    }
                }
            },
            duplicateCheck: function (query, id = false) {
                let queriesSplit = query.split("\n");
                // self check
                for (let qKey1 in queriesSplit) {
                  for (let qKey2 in queriesSplit) {
                    let tabSplit1 = queriesSplit[qKey1].split("\t");
                    let tabSplit2 = queriesSplit[qKey2].split("\t");
                    if (tabSplit1[0] == tabSplit2[0] && qKey1 != qKey2) {
                      this.duplicateQueries = true;
                      return true;
                    }
                  }
                }
                for (let qKey in queriesSplit) {
                    let tabSplit = queriesSplit[qKey].split("\t");
                    // console.log(tabSplit);
                    for (let key in this.searchQueries) {
                        if (id != key && tabSplit[0] == this.searchQueries[key].query) {
                            if (id) {
                              this.duplicateQueriesEdit[id] = true;
                            } else {
                              this.duplicateQueries = true;
                            }
                            return true;
                        } else {
                          if (id) {
                            this.duplicateQueriesEdit[key] = false;
                          }
                        }
                    }
                }
                this.duplicateQueries = false;
                return false;
            },
            lengthExceeding: function (query, id = false) {
              //disable function
              return false
              if (!this.typeRu) {
                return false;
              }

              let queriesSplit = query.split("\n");
              let rez = false;
              for (let key in queriesSplit) {
                rez = queriesSplit[key].length > 35 && queriesSplit[key].indexOf('|') != -1;
                if (id) {
                  this.upMaxLengthEdit[id] = rez;
                } else {
                  this.upMaxLength = rez;
                }
              }

              return rez;
            },
            handleFocusout: function (id) {
              if (
                  !this.duplicateCheck(this.searchQueries[id]['query'], id) &&
                  !this.lengthExceeding(this.searchQueries[id]['query'], id)
              ) {
                this.isEditQueries[id] = false
              } else {
                this.$nextTick(() => {
                  this.$refs['editQueries_'+ id][0].focus();
                });
                return false;
              }
            },
            setToClipboard: async function () {
                this.clipboardText = '';
                this.isCopyToClipboard = true;
                await this.$nextTick();
                for (let key in this.searchQueries) {
                    let val = this.searchQueries[key];
                    this.clipboardText += val.query +"\t"+ val.frequency +"\n";
                }
                await this.$nextTick();
                let textareaEl = this.$refs.clipboardRef.$el;
                textareaEl.select();
                textareaEl.setSelectionRange(0, 99999);
                try {
                    var successful = document.execCommand('copy');
                    var msg = successful ? 'successful' : 'unsuccessful';
                    console.log('Testing code was copied ' + msg);
                } catch (err) {
                    alert('Oops, unable to copy');
                }
                /* unselect the range */
                window.getSelection().removeAllRanges();
                this.isCopyToClipboard = false;
            }
        },
        mounted() {
            console.log(this.typeRu);
        }
    }
</script>

<style scoped>
    .search-link-box.col-4 {
        flex: 0 0 30%;
        max-width: 30%;
    }
    .search-name-box.col-8 {
        flex: 0 0 70%;
        max-width: 70%;
    }
    .search-query button.but-remove:focus {
        outline: none;
    }
    /*.query-aria::-webkit-scrollbar {*/
    /*    display: none;*/
    /*}*/
    /*.query-aria {*/
    /*    -ms-overflow-style: none;  !* IE and Edge *!*/
    /*    scrollbar-width: none;  !* Firefox *!*/
    /*}*/

    .search-query .query-input {
        height: 34px;
        width: 91%;
        margin-right: 5px;
        display: inline-block;
    }
    .but-add-queries {
        line-height: 34px;
    }
    .box-but-copy {
        text-align: right;
        margin-top: -12px;
        padding-right: 2px;
        padding-bottom: 5px;
    }
    .but-copy {
        font-size: 0.5rem;
        padding: 0 2px;
    }
</style>